import type { ReactNode } from 'react'
import './TrustBar.css'

export interface TrustBarProps {
  children: ReactNode
}

export function TrustBar({ children }: TrustBarProps) {
  return <div className="azoya-trust-bar">{children}</div>
}
